import React from 'react';

export default {
  outline: (
    <>
      <g
        id="bg-lines"
        transform="translate(1.000000, 0.000000)"
        strokeWidth="0.5"
      >
        <polyline
          id="Path"
          stroke="#262626"
          points="514 134 557 134 557 160 514 160 514 134"
        />
        <path d="M519.5,134 L519.5,160" id="Path" stroke="#262626" />
        <path d="M526.5,134 L526.5,160" id="Path" stroke="#262626" />
        <polyline
          id="Path"
          stroke="#262626"
          points="514 105 557 105 557 131 514 131 514 105"
        />
        <path d="M532.5,134 L532.5,160" id="Path" stroke="#262626" />
        <path d="M538.5,134 L538.5,160" id="Path" stroke="#262626" />
        <path d="M544.5,134 L544.5,160" id="Path" stroke="#262626" />
        <path d="M550.5,134 L550.5,160" id="Path" stroke="#262626" />
        <path d="M519.5,105 L519.5,131" id="Path" stroke="#262626" />
        <path d="M526.5,105 L526.5,131" id="Path" stroke="#262626" />
        <path d="M532.5,105 L532.5,131" id="Path" stroke="#262626" />
        <path d="M538.5,105 L538.5,131" id="Path" stroke="#262626" />
        <path d="M544.5,105 L544.5,131" id="Path" stroke="#262626" />
        <path d="M550.5,105 L550.5,131" id="Path" stroke="#262626" />
        <polygon
          id="Path"
          stroke="#979797"
          fillRule="nonzero"
          points="484 105 582 105 582 160 484 160"
        />
        <polyline
          id="Path"
          stroke="#262626"
          points="283 134 326 134 326 160 283 160 283 134"
        />
        <path d="M288.5,134 L288.5,160" id="Path" stroke="#262626" />
        <path d="M295.5,134 L295.5,160" id="Path" stroke="#262626" />
        <polyline
          id="Path"
          stroke="#262626"
          points="283 105 326 105 326 131 283 131 283 105"
        />
        <path d="M301.5,134 L301.5,160" id="Path" stroke="#262626" />
        <path d="M307.5,134 L307.5,160" id="Path" stroke="#262626" />
        <path d="M313.5,134 L313.5,160" id="Path" stroke="#262626" />
        <path d="M319.5,134 L319.5,160" id="Path" stroke="#262626" />
        <path d="M288.5,105 L288.5,131" id="Path" stroke="#262626" />
        <path d="M295.5,105 L295.5,131" id="Path" stroke="#262626" />
        <path d="M301.5,105 L301.5,131" id="Path" stroke="#262626" />
        <path d="M307.5,105 L307.5,131" id="Path" stroke="#262626" />
        <path d="M313.5,105 L313.5,131" id="Path" stroke="#262626" />
        <path d="M319.5,105 L319.5,131" id="Path" stroke="#262626" />
        <polygon
          id="Path"
          stroke="#979797"
          fillRule="nonzero"
          points="253 105 351 105 351 160 253 160"
        />
        <polyline
          id="Path"
          stroke="#262626"
          points="76.4400987 0.679983806 0.0847281568 0.679983806 0.0847281568 151.394999 76.4400987 151.394999 76.4400987 0.679983806"
        />
        <polyline
          id="Path"
          stroke="#262626"
          points="76.4400987 151.394999 0.0847281568 151.394999 0.0847281568 337.589387 76.4400987 337.589387 76.4400987 151.394999"
        />
        <polyline
          id="Path"
          stroke="#262626"
          points="678.634249 11.2901053 754.283933 11.2901053 754.283933 35.6376953"
        />
        <polyline
          id="Path"
          stroke="#262626"
          points="694 338.203017 694 342.123023 754.19513 342.123023 754.19513 311"
        />
        <polyline
          id="Path"
          stroke="#262626"
          points="524.16774 337.581796 524.16774 340.057491 450 340.057491 450 337.015923"
        />
        <polyline
          id="Path"
          stroke="#262626"
          points="387.814896 337.015923 387.814896 340.057491 314 340.057491 314 337.157391"
        />
        <polyline
          id="Path"
          stroke="#262626"
          points="305.022609 202.818721 259.505776 202.818721 259.505776 236.27597 305.022609 236.27597 305.022609 202.818721"
        />
        <path
          d="M364.863239,1.63841565 L451.397461,1.63841565"
          id="Path"
          stroke="#262626"
        />
        <polygon
          id="Path"
          stroke="#262626"
          fillRule="nonzero"
          points="255.271652 240.661487 255.271652 198.221001 309.256733 198.221001 309.256733 240.661487"
        />
        <path
          d="M483.879883,160 L436.323242,160"
          id="Path-2"
          stroke="#262626"
        />
      </g>
      <path
        d="M713.28,169.06 L712.8,170.5 L710,179.1 L709,179.1 L704.36,165.3 L703.2,165.2 L703.2,165 L708.2,165 L708.2,165.2 L706.26,165.3 L710.14,177.3 L710.34,177.3 L713.12,168.5 L712.16,165.3 L710.6,165.2 L710.6,165 L715.8,165 L715.8,165.2 L714.06,165.3 L717.44,177.3 L717.64,177.3 L720.66,165.9 L718.6,165.2 L718.6,165 L723,165 L723,165.2 L720.98,165.9 L717.4,179.1 L716.3,179.1 L713.28,169.06 Z M730.665,173.2 L723.825,173.2 C723.765,175.8 725.125,178.1 727.465,178.1 C728.765,178.1 730.165,177.2 730.665,176.2 L730.865,176.2 C730.465,177.8 728.965,179.2 727.065,179.2 C723.965,179.2 722.265,176.7 722.265,174 C722.265,170.7 724.665,168.8 727.165,168.8 C729.065,168.8 731.265,169.9 730.665,173.2 Z M727.065,169 C725.345,169 724.065,170.4 723.865,173 L728.865,172.9 C729.365,170.2 728.365,169 727.065,169 Z M736.43,179.2 C735.17,179.2 734.09,178.62 733.43,178 L733.33,179.2 L733.13,179.2 L733.13,176.2 L733.33,176.2 C733.57,176.88 733.93,177.56 734.39,178.1 C734.85,178.64 735.45,179 736.23,179 C737.63,179 738.53,178.12 738.53,176.9 C738.53,175.4 737.07,174.96 735.93,174.5 C734.39,173.88 733.23,173.2 733.23,171.5 C733.23,169.9 734.57,168.8 736.63,168.8 C737.45,168.8 738.53,169.1 739.43,169.9 L739.53,168.8 L739.73,168.8 L739.73,171.8 L739.53,171.8 C739.23,170.8 738.77,170.12 738.25,169.66 C737.73,169.22 737.13,169 736.53,169 C735.33,169 734.63,169.82 734.63,170.8 C734.63,172.1 735.93,172.7 737.03,173.1 C738.51,173.64 740.13,174.4 740.13,176.2 C740.13,178.1 738.53,179.2 736.43,179.2 Z M745.395,169.3 L745.395,176.8 C745.395,178.3 745.895,178.7 746.795,178.7 C747.195,178.7 747.695,178.6 748.395,178.3 L748.395,178.5 C747.395,179 746.795,179.2 745.795,179.2 C744.395,179.2 743.795,178.5 743.795,176.8 L743.795,169.3 L742.195,169.3 L742.195,169.1 L743.795,169 L745.195,166.6 L745.395,166.6 L745.395,169 L748.395,169 L748.395,169.3 L745.395,169.3 Z M755.725,178.8 L758.325,178.7 L758.325,165.5 L755.725,165.9 L755.725,165.7 L759.725,164.8 L759.925001,164.8 L759.925001,178.7 L762.525001,178.8 L762.525001,179 L755.725,179 L755.725,178.8 Z M768.790001,179 C770.710001,179 771.750001,177.36 771.750001,175.24 C771.750001,173.42 770.870001,171.64 768.730001,171.64 L768.010001,171.64 L768.010001,171.4 L768.530001,171.4 C770.350001,171.4 771.230001,169.66 771.230001,168.28 C771.230001,166.92 770.390001,165.6 768.790001,165.6 C766.790001,165.6 765.990001,166.9 765.590001,167.98 L765.390001,167.98 C765.790001,166.3 767.390001,164.8 769.290001,164.8 C771.430001,164.8 772.970001,166.06 772.970001,167.96 C772.970001,169.64 771.710001,170.84 769.430001,171.42 L769.430001,171.52 C771.810001,171.74 773.490001,172.92 773.490001,175.16 C773.490001,177.88 771.190001,179.2 768.690001,179.2 C766.510001,179.2 764.790001,177.9 764.790001,176.6 C764.790001,176.04 765.230001,175.6 765.790001,175.6 C767.250001,175.6 767.270001,177.88 765.490001,177.5 L765.490001,177.7 C765.990001,178.1 766.790001,179 768.790001,179 Z M779.155001,169.3 L779.155001,176.8 C779.155001,178.3 779.655001,178.7 780.555001,178.7 C780.955001,178.7 781.455001,178.6 782.155001,178.3 L782.155001,178.5 C781.155001,179 780.555001,179.2 779.555001,179.2 C778.155001,179.2 777.555001,178.5 777.555001,176.8 L777.555001,169.3 L775.955001,169.3 L775.955001,169.1 L777.555001,169 L778.955001,166.6 L779.155001,166.6 L779.155001,169 L782.155001,169 L782.155001,169.3 L779.155001,169.3 Z M793.820001,178.7 L795.620001,178.8 L795.620001,179 L790.820001,179 L790.820001,178.8 L792.220001,178.7 L792.220001,171.8 C792.220001,170.5 791.820001,169.4 790.320001,169.4 C789.420001,169.4 788.820001,169.7 787.420001,171.1 L787.420001,178.7 L789.220001,178.8 L789.220001,179 L784.020001,179 L784.020001,178.8 L785.820001,178.7 L785.820001,164.8 L784.220001,164.8 L784.220001,164.6 L787.220001,164.4 L787.420001,164.4 L787.420001,170.6 L787.620001,170.6 C788.780001,169.44 789.860001,168.8 791.320001,168.8 C792.660001,168.8 793.820001,169.6 793.820001,171.8 L793.820001,178.7 Z M804.250001,178.1 L806.350001,178.8 L806.350001,179 L801.950001,179 L801.950001,178.8 L803.930001,178.1 L807.790001,166.1 L809.250001,164.8 L814.390001,178.7 L815.550001,178.8 L815.550001,179 L810.550001,179 L810.550001,178.8 L812.490001,178.7 L810.830001,174 L805.530001,174 L804.250001,178.1 Z M808.150001,166.4 L807.950001,166.4 L805.590001,173.76 L810.750001,173.76 L808.150001,166.4 Z M821.075001,177.64 L821.275001,177.64 L823.755001,169.7 L822.215001,169.2 L822.215001,169 L825.815001,169 L825.815001,169.2 L824.055001,169.7 L821.015001,179.1 L819.915001,179.1 L815.955001,169.3 L814.615001,169.2 L814.615001,169 L819.815001,169 L819.815001,169.2 L817.855001,169.3 L821.075001,177.64 Z M835.080001,173.2 L828.240001,173.2 C828.180001,175.8 829.540001,178.1 831.880001,178.1 C833.180001,178.1 834.580001,177.2 835.080001,176.2 L835.280001,176.2 C834.880001,177.8 833.380001,179.2 831.480001,179.2 C828.380001,179.2 826.680001,176.7 826.680001,174 C826.680001,170.7 829.080001,168.8 831.580001,168.8 C833.480001,168.8 835.680001,169.9 835.080001,173.2 Z M831.480001,169 C829.760001,169 828.480001,170.4 828.280001,173 L833.280001,172.9 C833.780001,170.2 832.780001,169 831.480001,169 Z M846.945001,178.7 L848.745001,178.8 L848.745001,179 L843.945001,179 L843.945001,178.8 L845.345001,178.7 L845.345001,171.8 C845.345001,170.5 844.945001,169.4 843.445001,169.4 C842.545001,169.4 841.945001,169.7 840.545001,171.1 L840.545001,178.7 L842.345001,178.8 L842.345001,179 L837.145001,179 L837.145001,178.8 L838.945001,178.7 L838.945001,169.2 L837.345001,169.2 L837.345001,169 L840.345001,168.8 L840.545001,168.8 L840.545001,170.6 L840.745001,170.6 C841.905001,169.44 842.985001,168.8 844.445001,168.8 C845.785001,168.8 846.945001,169.6 846.945001,171.8 L846.945001,178.7 Z M851.410001,169.2 L849.610001,169.2 L849.610001,169 L852.610001,168.8 L853.010001,168.8 L853.010001,176.2 C853.010001,177.5 853.410001,178.6 854.910001,178.6 C855.810001,178.6 856.410001,178.3 857.610001,176.9 L857.610001,169.2 L855.810001,169.2 L855.810001,169 L858.810001,168.8 L859.210001,168.8 L859.210001,178.8 L861.010001,178.8 L861.010001,179 L857.810001,179.2 L857.610001,179.2 L857.610001,177.4 L857.410001,177.4 C856.410001,178.5 855.370001,179.2 853.910001,179.2 C852.570001,179.2 851.410001,178.4 851.410001,176.2 L851.410001,169.2 Z M870.875002,173.2 L864.035002,173.2 C863.975001,175.8 865.335002,178.1 867.675002,178.1 C868.975001,178.1 870.375002,177.2 870.875002,176.2 L871.075002,176.2 C870.675002,177.8 869.175002,179.2 867.275002,179.2 C864.175002,179.2 862.475001,176.7 862.475001,174 C862.475001,170.7 864.875002,168.8 867.375002,168.8 C869.275002,168.8 871.475001,169.9 870.875002,173.2 Z M867.275002,169 C865.555002,169 864.275002,170.4 864.075002,173 L869.075002,172.9 C869.575002,170.2 868.575002,169 867.275002,169 Z"
        id="West-13th-Avenue"
        fill="#1A373C"
        transform="translate(787.137501, 171.800000) rotate(-90.000000) translate(-787.137501, -171.800000) "
      />
      <path
        d="M310.5,372.1 L312.6,372.8 L312.6,373 L308.2,373 L308.2,372.8 L310.18,372.1 L314.04,360.1 L315.5,358.8 L320.64,372.7 L321.8,372.8 L321.8,373 L316.8,373 L316.8,372.8 L318.74,372.7 L317.08,368 L311.78,368 L310.5,372.1 Z M314.4,360.4 L314.2,360.4 L311.84,367.76 L317,367.76 L314.4,360.4 Z M326.665,365.4 L326.865,365.4 C327.765,363.8 328.565,362.8 329.565,362.8 C330.205,362.8 330.665,363.24 330.665,363.8 C330.665,365.2 328.665,365.3 328.565,363.7 L328.365,363.7 C327.845,364.2 327.365,364.9 326.665,366.3 L326.665,372.7 L328.465,372.8 L328.465,373 L323.265,373 L323.265,372.8 L325.065,372.7 L325.065,363.2 L323.465,363.2 L323.465,363 L326.465,362.8 L326.665,362.8 L326.665,365.4 Z M334.73,364.44 L334.73,371.96 C335.53,372.5 336.21,372.9 337.23,372.9 C338.91,372.9 340.33,371.6 340.33,368 C340.33,364.4 338.91,363.2 337.23,363.2 C336.21,363.2 335.33,363.92 334.73,364.44 Z M333.13,373.2 L333.13,358.8 L331.53,358.8 L331.53,358.6 C332.27,358.56 333.01,358.5 334.53,358.4 L334.73,358.4 L334.73,364 L334.93,364 C335.73,363.3 336.73,362.8 337.93,362.8 C340.53,362.8 342.13,365 342.13,368 C342.13,371 340.13,373.2 337.53,373.2 C336.73,373.2 335.93,373.1 334.93,372.4 L334.73,372.4 L333.33,373.2 L333.13,373.2 Z M345.395,363.2 L343.595,363.2 L343.595,363 L346.595,362.8 L346.995,362.8 L346.995,370.2 C346.995,371.5 347.395,372.6 348.895,372.6 C349.795,372.6 350.395,372.3 351.595,370.9 L351.595,363.2 L349.795,363.2 L349.795,363 L352.795,362.8 L353.195,362.8 L353.195,372.8 L354.995,372.8 L354.995,373 L351.795,373.2 L351.595,373.2 L351.595,371.4 L351.395,371.4 C350.395,372.5 349.355,373.2 347.895,373.2 C346.555,373.2 345.395,372.4 345.395,370.2 L345.395,363.2 Z M359.46,363.3 L359.46,370.8 C359.46,372.3 359.96,372.7 360.86,372.7 C361.26,372.7 361.76,372.6 362.46,372.3 L362.46,372.5 C361.46,373 360.86,373.2 359.86,373.2 C358.46,373.2 357.86,372.5 357.86,370.8 L357.86,363.3 L356.26,363.3 L356.26,363.1 L357.86,363 L359.26,360.6 L359.46,360.6 L359.46,363 L362.46,363 L362.46,363.3 L359.46,363.3 Z M365.725,363.2 L363.925001,363.2 L363.925001,363 L366.925001,362.8 L367.325,362.8 L367.325,370.2 C367.325,371.5 367.725,372.6 369.225,372.6 C370.125,372.6 370.725,372.3 371.925001,370.9 L371.925001,363.2 L370.125,363.2 L370.125,363 L373.125,362.8 L373.525001,362.8 L373.525001,372.8 L375.325,372.8 L375.325,373 L372.125,373.2 L371.925001,373.2 L371.925001,371.4 L371.725,371.4 C370.725,372.5 369.685001,373.2 368.225,373.2 C366.885001,373.2 365.725,372.4 365.725,370.2 L365.725,363.2 Z M380.290001,373.2 C379.030001,373.2 377.950001,372.62 377.290001,372 L377.190001,373.2 L376.990001,373.2 L376.990001,370.2 L377.190001,370.2 C377.430001,370.88 377.790001,371.56 378.250001,372.1 C378.710001,372.64 379.310001,373 380.090001,373 C381.490001,373 382.390001,372.12 382.390001,370.9 C382.390001,369.4 380.930001,368.96 379.790001,368.5 C378.250001,367.88 377.090001,367.2 377.090001,365.5 C377.090001,363.9 378.430001,362.8 380.490001,362.8 C381.310001,362.8 382.390001,363.1 383.290001,363.9 L383.390001,362.8 L383.590001,362.8 L383.590001,365.8 L383.390001,365.8 C383.090001,364.8 382.630001,364.12 382.110001,363.66 C381.590001,363.22 380.990001,363 380.390001,363 C379.190001,363 378.490001,363.82 378.490001,364.8 C378.490001,366.1 379.790001,366.7 380.890001,367.1 C382.370001,367.64 383.990001,368.4 383.990001,370.2 C383.990001,372.1 382.390001,373.2 380.290001,373.2 Z M392.220001,371.6 L392.020001,373.1 L391.820001,373.1 L391.720001,368.8 L391.920001,368.8 C392.080001,369.26 392.260001,369.74 392.420001,370.2 C393.200001,372.4 394.760001,373 396.080001,373 C397.900001,373 399.020001,372 399.020001,370.08 C399.020001,367.8 397.080001,367.04 395.580001,366.4 C393.560001,365.54 392.020001,364.4 392.020001,362.36 C392.020001,360.4 393.520001,358.8 396.260001,358.8 C397.480001,358.8 398.620001,359.2 399.520001,360.14 L399.720001,358.9 L399.920001,358.9 L400.020001,362.9 L399.820001,362.9 C399.620001,362.34 399.420001,361.76 399.220001,361.2 C398.660001,359.6 397.600001,359 396.280001,359 C394.600001,359 393.320001,360.1 393.320001,361.6 C393.320001,363.5 395.140001,364.32 396.580001,364.9 C398.580001,365.7 400.520001,367 400.520001,369.2 C400.520001,371.6 398.760001,373.2 396.080001,373.2 C394.640001,373.2 393.220001,372.5 392.220001,371.6 Z M405.985001,363.3 L405.985001,370.8 C405.985001,372.3 406.485001,372.7 407.385001,372.7 C407.785001,372.7 408.285001,372.6 408.985001,372.3 L408.985001,372.5 C407.985001,373 407.385001,373.2 406.385001,373.2 C404.985001,373.2 404.385001,372.5 404.385001,370.8 L404.385001,363.3 L402.785001,363.3 L402.785001,363.1 L404.385001,363 L405.785001,360.6 L405.985001,360.6 L405.985001,363 L408.985001,363 L408.985001,363.3 L405.985001,363.3 Z M414.250001,365.4 L414.450001,365.4 C415.350001,363.8 416.150001,362.8 417.150001,362.8 C417.790001,362.8 418.250001,363.24 418.250001,363.8 C418.250001,365.2 416.250001,365.3 416.150001,363.7 L415.950001,363.7 C415.430001,364.2 414.950001,364.9 414.250001,366.3 L414.250001,372.7 L416.050001,372.8 L416.050001,373 L410.850001,373 L410.850001,372.8 L412.650001,372.7 L412.650001,363.2 L411.050001,363.2 L411.050001,363 L414.050001,362.8 L414.250001,362.8 L414.250001,365.4 Z M427.915001,367.2 L421.075001,367.2 C421.015001,369.8 422.375001,372.1 424.715001,372.1 C426.015001,372.1 427.415001,371.2 427.915001,370.2 L428.115001,370.2 C427.715001,371.8 426.215001,373.2 424.315001,373.2 C421.215001,373.2 419.515001,370.7 419.515001,368 C419.515001,364.7 421.915001,362.8 424.415001,362.8 C426.315001,362.8 428.515001,363.9 427.915001,367.2 Z M424.315001,363 C422.595001,363 421.315001,364.4 421.115001,367 L426.115001,366.9 C426.615001,364.2 425.615001,363 424.315001,363 Z M438.780001,367.2 L431.940001,367.2 C431.880001,369.8 433.240001,372.1 435.580001,372.1 C436.880001,372.1 438.280001,371.2 438.780001,370.2 L438.980001,370.2 C438.580001,371.8 437.080001,373.2 435.180001,373.2 C432.080001,373.2 430.380001,370.7 430.380001,368 C430.380001,364.7 432.780001,362.8 435.280001,362.8 C437.180001,362.8 439.380001,363.9 438.780001,367.2 Z M435.180001,363 C433.460001,363 432.180001,364.4 431.980001,367 L436.980001,366.9 C437.480001,364.2 436.480001,363 435.180001,363 Z M444.245001,363.3 L444.245001,370.8 C444.245001,372.3 444.745001,372.7 445.645001,372.7 C446.045001,372.7 446.545001,372.6 447.245001,372.3 L447.245001,372.5 C446.245001,373 445.645001,373.2 444.645001,373.2 C443.245001,373.2 442.645001,372.5 442.645001,370.8 L442.645001,363.3 L441.045001,363.3 L441.045001,363.1 L442.645001,363 L444.045001,360.6 L444.245001,360.6 L444.245001,363 L447.245001,363 L447.245001,363.3 L444.245001,363.3 Z"
        id="Arbutus-Street"
        fill="#1A373C"
      />
    </>
  ),
  units: [
    {
      id: '203-303',
      mockup: (
        <g id="203" transform="translate(312.000000, 1.000000)">
          <polygon
            id="fill-203"
            stroke="#262626"
            strokeWidth="1.5"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="0.349720053 0.175122807 54.0525269 0.175122807 54.0525269 31.0859433 140.216952 15.8781026 140.216952 0.175122807 212.549904 0.175122807 212.549904 103.942111 172.537432 103.942111 172.537432 136.762753 124.762399 136.762753 124.762399 158.690337 90.0425814 158.690337 90.0425814 155.365833 40.0093488 155.365833 40.0093488 103.942111 0.561426256 103.942111"
          />
          <text
            fontFamily="GlosaDisplay-Roman, Glosa Display"
            fontSize="37"
            fontWeight="normal"
            fill="#A27E42"
          >
            <tspan x="73.3243369" y="87">
              203
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: '202',
      mockup: (
        <g id="202" transform="translate(78.000000, 1.000000)">
          <polygon
            id="fill-202"
            stroke="#262626"
            strokeWidth="1.5"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="234.327302 0.175122807 234.327302 103.942111 175.33184 103.942111 175.33184 155.365833 120.71164 155.365833 120.71164 184.154629 66.9382643 184.154629 66.9382643 150.272974 0.109672904 150.272974 0.109672904 0.175122807"
          />
          <text
            fontFamily="GlosaDisplay-Roman, Glosa Display"
            fontSize="37"
            fontWeight="normal"
            fill="#A27E42"
          >
            <tspan x="72.7868369" y="87">
              202
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: '201',
      mockup: (
        <g id="201" transform="translate(78.000000, 151.000000)">
          <polygon
            id="fill-201"
            stroke="#262626"
            strokeWidth="1.5"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="0.109672904 0.517022942 67.0048828 0.517022942 67.0048828 34.5401457 120.570502 34.5401457 120.570502 38.9256626 159.101031 38.9256626 159.101031 36.0255628 170.32146 36.0255628 170.32146 96.3617868 171.238854 96.3617868 171.238854 186.830756 0.109672904 186.830756"
          />
          <text
            fontFamily="GlosaDisplay-Roman, Glosa Display"
            fontSize="37"
            fontWeight="normal"
            fill="#A27E42"
          >
            <tspan x="47.9284881" y="120">
              201
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: '207-307',
      mockup: (
        <g id="207" transform="translate(249.000000, 187.000000)">
          <polygon
            id="fill-207"
            stroke="#262626"
            strokeWidth="1.5"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="193.619604 150.689287 140.128503 150.689287 126.791012 122.39563 65.6079196 150.689287 0.472977752 150.689287 0.472977752 60.5032551 68.3601002 60.5032551 68.3601002 0.167031039 126.226462 0.167031039 126.226462 2.92566262 167.156328 2.92566262 167.156328 0.025562753 179.294151 0.025562753 179.294151 34.260888 193.83131 34.260888"
          />
          <text
            fontFamily="GlosaDisplay-Roman, Glosa Display"
            fontSize="37"
            fontWeight="normal"
            fill="#A27E42"
          >
            <tspan x="94.1568369" y="84">
              207
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: '206-306',
      mockup: (
        <g id="206" transform="translate(428.000000, 187.000000)">
          <polygon
            id="fill-206"
            stroke="#262626"
            strokeWidth="1.5"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="153.287167 151.184426 98.2873163 151.184426 84.5917014 122.254162 21.838249 150.547819 15.244064 150.547819 15.244064 34.3795573 0.31656844 34.3795573 0.31656844 0.025562753 63.5048023 0.025562753 63.5048023 3.35006748 104.44672 3.35006748 104.44672 0.308499325 153.287167 0.308499325"
          />
          <text
            fontFamily="GlosaDisplay-Roman, Glosa Display"
            fontSize="37"
            fontWeight="normal"
            fill="#A27E42"
          >
            <tspan x="50.7693369" y="84">
              206
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: '205-305',
      mockup: (
        <g id="205" transform="translate(581.000000, 186.000000)">
          <polygon
            id="fill-205"
            stroke="#262626"
            strokeWidth="1.5"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="178.777914 123.466364 114.489797 134.783827 114.489797 152.113692 0.521290703 152.113692 0.521290703 1.02556275 12.8002505 1.02556275 12.8002505 4.35006748 53.2361353 4.35006748 53.2361353 0.530423752 178.777914 0.530423752"
          />
          <text
            fontFamily="GlosaDisplay-Roman, Glosa Display"
            fontSize="37"
            fontWeight="normal"
            fill="#A27E42"
          >
            <tspan x="53.3243369" y="85">
              205
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: '204',
      mockup: (
        <g id="204" transform="translate(525.000000, 1.000000)">
          <polygon
            id="fill-204"
            stroke="#262626"
            strokeWidth="1.5"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="234.777914 185.144907 109.236135 185.144907 109.236135 155.719503 57.7915279 155.719503 57.7915279 103.871377 0.0663032268 103.871377 0.0663032268 0.175122807 154.470694 0.175122807 154.470694 48.4158084 231.531752 34.7641188 234.848482 53.0842618"
          />
          <text
            fontFamily="GlosaDisplay-Roman, Glosa Display"
            fontSize="37"
            fontWeight="normal"
            fill="#A27E42"
          >
            <tspan x="97.6768369" y="103">
              204
            </tspan>
          </text>
        </g>
      ),
    },
  ],
};
